import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { buildSign } from 'Pages/Dashboard/components/View Data/components/NewPage/VNetTagUpdate';

const proxy = 'https://api.eu.v-box.net/m16/we-data';



const initialState = {
  sid: '',
  tagMap: {}, //  { tagName: { boxId, monitorId, devtype } }
};

//  Common Header Builder
const buildHeader = ({ cuid, ts, sign, sid }) => ({
  dap: "",
  cuid,
  sv: "1.0",
  mt: "255",
  lan: "zh",
  sign,
  pid: "1",
  ts,
  sid,
});

//  LOGIN
export const vNetLogin = createAsyncThunk('vnet/login', async ({ vNetUsername, vNetPassword, cuid, ts, sign }) => {
  const res = await fetch(`${proxy}/sign/login?alias=${vNetUsername}&password=${vNetPassword}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      wcommon: JSON.stringify(buildHeader({ cuid, ts, sign })),
    },
  });

  return await res.json();
});

//  DEVICE LIST
export const vNetGetDeviceList = createAsyncThunk('vnet/devices', async ({ cuid, ts, sign, sid }) => {
  const res = await fetch(`${proxy}/device/getList`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      wcommon: JSON.stringify(buildHeader({ cuid, ts, sign, sid })),
    },
  });

  return await res.json();
});

//  GROUPS
export const vNetGetTagGroups = createAsyncThunk('vnet/groups', async ({ boxId, cuid, ts, sign, sid }) => {
  const res = await fetch(`${proxy}/actGroup?boxId=${boxId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      wcommon: JSON.stringify(buildHeader({ cuid, ts, sign, sid })),
    },
  });

  return await res.json();
});

//  TAG CONFIG
export const vNetGetTagConfig = createAsyncThunk(
  'vnet/config',
  async ({
    boxId,
    groupId,
    devtype,
    cuid,
    ts,
    sign,
    sid,
    page = 1,
    pageSize = 100,
  }) => {
    const res = await fetch(
      `${proxy}/realcfgs?boxId=${boxId}&groupId=${groupId}&devtype=${devtype}&page=${page}&pageSize=${pageSize}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          wcommon: JSON.stringify(buildHeader({ cuid, ts, sign, sid })),
        },
      }
    );

    return await res.json();
  }
);


//  UPDATE TAG
export const vNetUpdateTagValue = createAsyncThunk('vnet/update', async ({ boxId, monitorId, value, devtype, cuid, ts, sign, sid }) => {
  const res = await fetch(
    `${proxy}/updrealdata?boxId=${boxId}&monitorId=${monitorId}&value=${value}&devtype=${devtype}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        wcommon: JSON.stringify(buildHeader({ cuid, ts, sign, sid })),
      },
    }
  );

  return await res.json();
});

//  BUILD TAG MAP ( MOST IMPORTANT)
export const buildTagMap = createAsyncThunk(
  'vnet/buildTagMap',
  async ({ cuid, sid, devtype = "0", dispatch }) => {

    const tagMap = {};

    // 🔹 STEP 1: GET DEVICES
    const ts1 = Date.now();
    const sign1 = buildSign({
      cuid,
      sid,
      ts: ts1.toString(),
      mt: "255",
      pid: "1",
      sv: "1.0",
      lan: "zh",
    });

    const deviceRes = await dispatch(
      vNetGetDeviceList({ cuid, ts: ts1, sign: sign1, sid })
    ).unwrap();

    //  FIX: handle nested structure
    const boxes = deviceRes?.result?.list?.flatMap(g => g.boxList) || [];

    //  LOOP ALL BOXES
    for (const box of boxes) {
      const boxId = box.boxId;

      //  STEP 2: GET GROUPS
      const ts2 = Date.now();
      const sign2 = buildSign({
        boxId: boxId.toString(),
        cuid,
        sid,
        ts: ts2.toString(),
        mt: "255",
        pid: "1",
        sv: "1.0",
        lan: "zh",
      });

      const groupRes = await dispatch(
        vNetGetTagGroups({ boxId, cuid, ts: ts2, sign: sign2, sid })
      ).unwrap();

      const groups = groupRes?.result?.list || [];

      //  LOOP ALL GROUPS
      for (const group of groups) {
        const groupId = group.groupId;

        let page = 1;
        let hasMore = true;

        //  PAGINATION LOOP
        while (hasMore) {

          const ts3 = Date.now();
          const sign3 = buildSign({
            boxId: boxId.toString(),
            groupId: groupId.toString(),
            devtype,
            cuid,
            sid,
            ts: ts3.toString(),
            mt: "255",
            pid: "1",
            sv: "1.0",
            lan: "zh",
            page: page.toString(),
            pageSize: "100",
          });

          const cfgRes = await dispatch(
            vNetGetTagConfig({
              boxId,
              groupId,
              devtype,
              cuid,
              ts: ts3,
              sign: sign3,
              sid,
              page,
              pageSize: 100,
            })
          ).unwrap();

          const cfgList = cfgRes?.result?.cfgList || [];

          //  STORE TAGS
          for (const tag of cfgList) {
            tagMap[tag.monitorName] = {
              boxId,
              monitorId: tag.monitorId,
              devtype,
            };
          }

          //  STOP CONDITION
          if (cfgList.length < 100) {
            hasMore = false;
          } else {
            page++;
          }
        }
      }
    }


    return tagMap;
  }
);

//  SLICE
const vNetSlice = createSlice({
  name: 'vnet',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(vNetLogin.fulfilled, (state, action) => {
      state.sid = action.payload?.result?.sid;
    });

    builder.addCase(buildTagMap.fulfilled, (state, action) => {
      state.tagMap = action.payload;
    });
  },
});

export default vNetSlice.reducer;